import React from 'react'
import { useTranslation } from 'react-i18next';

const Checkout = () => 
  {
  const { t } = useTranslation();

  return (
    <div>
  <main className="page-content">
    <div className="tm-section tm-checkout-area bg-white tm-padding-section">
      <div className="container">
        <div className="tm-checkout-coupon">
          <a href="#checkout-couponform" data-toggle="collapse"><span>{t("CO1")}</span> {t("CO2")}</a>
          <div id="checkout-couponform" className="collapse">
            <form action="#" className="tm-checkout-couponform">
              <input type="text" id="coupon-field" placeholder="Enter coupon code" required="required" />
              <button type="submit" className="tm-button">{t("CO3")}</button>
            </form>
          </div>
        </div>
        <form action="#" className="tm-form tm-checkout-form">
          <div className="row">
            <div className="col-lg-6">
              <h4 className="small-title">{t("CO4")}</h4>
              <div className="tm-checkout-billingform">
                <div className="tm-form-inner">
                  <div className="tm-form-field tm-form-fieldhalf">
                    <label htmlFor="billingform-firstname">{t("CO5")}</label>
                    <input type="text" id="billingform-firstname" />
                  </div>
                  <div className="tm-form-field tm-form-fieldhalf">
                    <label htmlFor="billingform-lastname">{t("CO6")}</label>
                    <input type="text" id="billingform-lastname" />
                  </div>
                  <div className="tm-form-field">
                    <label htmlFor="billingform-companyname">{t("CO7")}</label>
                    <input type="text" id="billingform-companyname" />
                  </div>
                  <div className="tm-form-field">
                    <label htmlFor="billingform-email">{t("CO8")}</label>
                    <input type="email" id="billingform-email" />
                  </div>
                  <div className="tm-form-field">
                    <label htmlFor="billingform-phone">{t("CO9")}</label>
                    <input type="text" id="billingform-phone" />
                  </div>
                  <div className="tm-form-field">
                    <label htmlFor="billingform-country">{t("CO10")}</label>
                    <select name="billingform-country" id="billingform-country">
                      <option value="bangladesh">{t("CO11")}</option>
                      <option value="bangladesh">{t("CO12")}</option>
                      <option value="bangladesh">{t("CO13")}</option>
                      <option value="bangladesh">{t("CO14")}</option>
                      <option value="bangladesh">{t("CO15")}</option>
                      <option value="bangladesh">{t("CO16")}</option>
                    </select>
                  </div>
                  <div className="tm-form-field">
                    <label htmlFor="billingform-address">{t("CO17")}</label>
                    <input type="text" id="billingform-address" placeholder="Apartment, Street Address" />
                  </div>
                  <div className="tm-form-field tm-form-fieldhalf">
                    <label htmlFor="billingform-streetaddress">{t("CO18")}</label>
                    <input type="text" id="billingform-streetaddress" />
                  </div>
                  <div className="tm-form-field tm-form-fieldhalf">
                    <label htmlFor="billingform-zipcode">{t("CO19")}</label>
                    <input type="text" id="billingform-zipcode" />
                  </div>
                  <div className="tm-form-field">
                    <input type="checkbox" name="billform-dirrentswitch" id="billform-dirrentswitch" />
                    <label htmlFor="billform-dirrentswitch"><b>{t("CO20")}</b></label>
                  </div>
                </div>
              </div>
              <div className="tm-checkout-differentform">
                <div className="tm-form-inner">
                  <div className="tm-form-field tm-form-fieldhalf">
                    <label htmlFor="differentform-firstname">{t("CO21")}</label>
                    <input type="text" id="differentform-firstname" />
                  </div>
                  <div className="tm-form-field tm-form-fieldhalf">
                    <label htmlFor="differentform-lastname">{t("CO22")}</label>
                    <input type="text" id="differentform-lastname" />
                  </div>
                  <div className="tm-form-field">
                    <label htmlFor="differentform-companyname">{t("CO23")}</label>
                    <input type="text" id="differentform-companyname" />
                  </div>
                  <div className="tm-form-field">
                    <label htmlFor="differentform-email">{t("CO24")}</label>
                    <input type="email" id="differentform-email" />
                  </div>
                  <div className="tm-form-field">
                    <label htmlFor="differentform-phone">{t("CO25")}</label>
                    <input type="text" id="differentform-phone" />
                  </div>
                  <div className="tm-form-field">
                    <label htmlFor="differentform-country">{t("CO26")}</label>
                    <select name="differentform-country" id="differentform-country">
                    <option value="bangladesh">{t("CO11")}</option>
                      <option value="bangladesh">{t("CO12")}</option>
                      <option value="bangladesh">{t("CO13")}</option>
                      <option value="bangladesh">{t("CO14")}</option>
                      <option value="bangladesh">{t("CO15")}</option>
                      <option value="bangladesh">{t("CO16")}</option>
                    </select>
                  </div>
                  <div className="tm-form-field">
                    <label htmlFor="differentform-address">{t("CO17")}</label>
                    <input type="text" id="differentform-address" placeholder="Apartment, Street Address" />
                  </div>
                  <div className="tm-form-field tm-form-fieldhalf">
                    <label htmlFor="differentform-streetaddress">{t("CO18")}</label>
                    <input type="text" id="differentform-streetaddress" />
                  </div>
                  <div className="tm-form-field tm-form-fieldhalf">
                    <label htmlFor="differentform-zipcode">{t("CO19")}</label>
                    <input type="text" id="differentform-zipcode" />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="tm-checkout-orderinfo">
                <div className="table-responsive">
                  <table className="table table-borderless tm-checkout-ordertable">
                    <thead>
                      <tr>
                        <th>{t("CO27")}</th>
                        <th>{t("CO28")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{t("CO29")}</td>
                        <td>₹ 75.00</td>
                      </tr>
                      <tr>
                        <td>{t("CO30")}</td>
                        <td>₹ 70.50</td>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr className="tm-checkout-subtotal">
                        <td>{t("CO31")}</td>
                        <td>₹ 175.00</td>
                      </tr>
                      <tr className="tm-checkout-shipping">
                        <td>(+) {t("CO32")}</td>
                        <td>₹ 15.00</td>
                      </tr>
                      <tr className="tm-checkout-total">
                        <td>{t("CO28")}</td>
                        <td>₹ 190.00</td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
                <div className="tm-checkout-payment">
                  <h4>{t("CO33")}</h4>
                  <div className="tm-form-inner">
                    <div className="tm-form-field">
                      <input type="radio" name="checkout-payment-method" id="checkout-payment-banktransfer" />
                      <label htmlFor="checkout-payment-banktransfer">{t("CO34")}</label>
                      <div className="tm-checkout-payment-content">
                        <p>{t("CO35")}</p>
                      </div>
                    </div>
                    <div className="tm-form-field">
                      <input type="radio" name="checkout-payment-method" id="checkout-payment-checkpayment" defaultChecked="checked" />
                      <label htmlFor="checkout-payment-checkpayment">{t("CO36")}</label>
                      <div className="tm-checkout-payment-content">
                        <p>{t("CO37")}</p>
                      </div>
                    </div>
                    <div className="tm-form-field">
                      <input type="radio" name="checkout-payment-method" id="checkout-payment-cashondelivery" />
                      <label htmlFor="checkout-payment-cashondelivery">{t("CO38")}</label>
                      <div className="tm-checkout-payment-content">
                        <p>{t("CO39")}.</p>
                      </div>
                    </div>
                    <div className="tm-form-field">
                      <input type="radio" name="checkout-payment-method" id="checkout-payment-paypal" />
                      <label htmlFor="checkout-payment-paypal">PayPal</label>
                      <div className="tm-checkout-payment-content">
                        <p>{t("CO40")}</p>
                      </div>
                    </div>
                    <div className="tm-form-field">
                      <input type="radio" name="checkout-payment-method" id="checkout-payment-creditcard" />
                      <label htmlFor="checkout-payment-creditcard">{t("CO41")}</label>
                      <div className="tm-checkout-payment-content">
                        <p>{t("CO42")}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="tm-checkout-submit">
                  <p>{t("CO43")}</p>
                  <div className="tm-form-inner">
                    <div className="tm-form-field">
                      <input type="checkbox" name="checkout-read-terms" id="checkout-read-terms" />
                      <label htmlFor="checkout-read-terms">{t("CO44")}</label>
                    </div>
                    <div className="tm-form-field">
                      <button type="submit" className="tm-button ml-auto">{t("CO45")}</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </main>
</div>

  )
}

export default Checkout
